<template>
  <div v-once>
    <div class="hero" >
      <div class="hero-head">
        <header class="nav">
          <div class="nav-left">
            <router-link :to="`/chapter/${this.chapter.id}`" class="nav-item">
              <span class="icon"><i class="ion ion-ios-arrow-back"></i></span>
              Return to Overview
            </router-link>
          </div>
        </header>
      </div>
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-size-2">{{chapter.artist}}: {{ chapter.title }}</h1>
          <h2 class="subtitle is-size-4">{{ chapter.author }}</h2>
        </div>
      </div>
    </div>
    <article class="section">
      <div class="container">
        <div class="content is-medium" v-html="essay" >
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Essay',
  props: ['id'],
  computed: {
    ...mapGetters(['chapter']),
    essay () {
      return require(`@/assets/data/${this.chapter.shortname}/introduction.md`)
    }
  }
}

</script>

<style scoped>
.container {
  max-width: 820px;
}

.hero {
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/Essay.vue?dc16e376